import CryptoJS from "crypto-js"

/**
 * @description 加密
 * @param word 加密内容
 * @param keyStr 密钥
 */
export function encrypt(word: string, keyStr: string) {
	const key = CryptoJS.enc.Utf8.parse(keyStr);
	const srcs = CryptoJS.enc.Utf8.parse(word);
	const encrypted = CryptoJS.AES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return encrypted.toString();
}

/**
 * @description 解密
 * @param word 解密内容
 * @param keyStr 密钥
*/
export function decrypt(word: string, keyStr: string) {
	const key = CryptoJS.enc.Utf8.parse(keyStr);
	const base64 = CryptoJS.enc.Base64.parse(word);
	const src = CryptoJS.enc.Base64.stringify(base64);
	const decrypt = CryptoJS.AES.decrypt(src, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	return decrypt.toString(CryptoJS.enc.Utf8);
}